// Web: Metro picks this file over index.ts, see RemoteSVGWeb.
export { default } from 'app/components/RemoteSVGWeb';
export * from 'app/components/RemoteSVGWeb';
